import React, {
  FunctionComponent, ReactElement, ReactNode, useEffect, useRef, useState,
} from 'react';
import ChevronIcon from '../icons/ChevronIcon';
import Typography from '../typography/Typography';
import './accordion.scss';

export type AccordionProps = {
  title?: string;
  text?: string;
  className?: string;
  icon?: ReactElement;
  nodeElement?: ReactNode;
}

const Accordion: FunctionComponent<AccordionProps> = ({
  title, text, className = '', icon, nodeElement,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [onlyText, setOnlyText] = useState(false);
  const contentEl = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (contentEl?.current?.scrollHeight === contentEl?.current?.offsetHeight && !title) {
      setOnlyText(true);
    }
  }, []);

  useEffect(() => {
    if (contentEl?.current?.scrollHeight === contentEl?.current?.offsetHeight && !title) {
      setOnlyText(true);
    }
  }, []);

  return (
    <div
      data-testid="accordion"
      className={`accordion w-12  p-t-12 ${className} ${isCollapsed ? 'collapsed' : ''}`}
    >
      <div
        className={`d-flex ${title ? 'align-items-center' : 'align-items-stretch'} justify-content-space-between p-b-20 p-r-16 pointer  ${isCollapsed && 'show-all'}`}
        onClick={() => !onlyText && setIsCollapsed(!isCollapsed)}
      >
        <div className={`d-flex ${title ? 'align-items-center' : 'align-items-stretch w-11 overflow-hidden'}`}>
          { icon }

          {(title || nodeElement) && <Typography variant="subtitle1" className={`${icon ? 'm-l-5' : ''}`}>{title}</Typography>}

          {(!title && !nodeElement) && (
          <div
            ref={contentEl}
            style={
            isCollapsed
              ? { height: contentEl.current!.scrollHeight + 8 }
              : { height: '24px' }
            }
            className="w-12 m-l-5 transition"
          >

            <Typography
              variant="body1"
              className="ellipsis"
            >
              {text}
            </Typography>
          </div>
          )}
        </div>

        { (!onlyText) && (
        <ChevronIcon
          className={`chevron-icon ${!title && 'm-t-5'}`}
          width={14}
          direction={isCollapsed ? 'top' : 'bottom'}
        />
        )}
      </div>

      { (title || nodeElement) && (

      <div
        className="accordion-text"
        ref={contentEl}
        style={
          isCollapsed
            ? { height: contentEl.current!.scrollHeight + 8 }
            : { height: '0px' }
        }
      >
        {!nodeElement ? <Typography variant="body1">{text}</Typography> : nodeElement}
      </div>
      )}
    </div>
  );
};

export default Accordion;
